import { render, staticRenderFns } from "./NotificationDetails.vue?vue&type=template&id=337b1ca4&scoped=true"
import script from "./NotificationDetails.vue?vue&type=script&lang=js"
export * from "./NotificationDetails.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetails.vue?vue&type=style&index=0&id=337b1ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b1ca4",
  null
  
)

export default component.exports